import { DateUtils } from '../../../../../helpers/utils/date.utils';
import { TIPO_FORMA_PAGTO_CARTAO, TIPO_FORMA_PAGTO_DINHEIRO } from './passoDoisConstants';

/**
 * Lógica pura do Passo 2 — port de `acordoPassoDoisController.js` real, sem
 * `FieldModel` (o protótipo usa `useState` de valores primitivos, mesmo
 * padrão já usado em `AcaoRequisicaoProcesso.jsx`). Datas trafegam em ISO
 * (`yyyy-MM-dd`, formato nativo de `<input type="date">`), não no formato
 * brasileiro que a tela real usa internamente — evita o round-trip
 * `toBrazilianDate`/`toAmericanDate` que só fazia sentido para o campo de
 * data customizado (`DateField`) de produção.
 */
export function hojeMaisDias(dias) {
  const data = new Date();
  data.setDate(data.getDate() + dias);
  // Monta a partir de getters locais, não `toISOString()` — este último
  // converte para UTC antes de formatar, produzindo a data seguinte para
  // qualquer horário local a partir de ~21h no fuso do Brasil (UTC-3).
  const ano = data.getFullYear();
  const mes = String(data.getMonth() + 1).padStart(2, '0');
  const dia = String(data.getDate()).padStart(2, '0');
  return `${ano}-${mes}-${dia}`;
}

export function ehFormaPagamentoComParcelaUnica(idTipoFormaPagto) {
  return idTipoFormaPagto === TIPO_FORMA_PAGTO_CARTAO || idTipoFormaPagto === TIPO_FORMA_PAGTO_DINHEIRO;
}

export function makeFormFields(dadosDefault) {
  return {
    dataPrimeiroVencimento: (dadosDefault?.dataPrimeiroVencimento || '').slice(0, 10) || hojeMaisDias(1),
    idTipoFormaPagto: dadosDefault?.idTipoFormaPagto || 0,
    idIntervaloPagamento: dadosDefault?.idIntervaloPagamento ?? 2,
    quantidadeParcelas: dadosDefault?.quantidadeParcelas || 1,
    porcentagemJuros: dadosDefault?.porcentagemJuros || '',
    porcentagemHonorarios: dadosDefault?.porcentagemHonorarios || '',
    porcentagemDesconto: dadosDefault?.porcentagemDesconto || 0,
  };
}

export function makePayloadRecalculo(formFields, idsTitulos, dadosDefault, ehMemoriaDeCalculo = false) {
  return {
    idsTitulos,
    porcentagemTaxaJuros: Number(formFields.porcentagemJuros) || 0,
    porcentagemHonorarios: Number(formFields.porcentagemHonorarios) || 0,
    porcentagemDesconto: dadosDefault?.temCampanha === 'N' ? 0 : Number(formFields.porcentagemDesconto) || 0,
    qtdeParcelas: formFields.quantidadeParcelas,
    idIntervaloPagamento: formFields.idIntervaloPagamento,
    dataPrimeiroVencimento: formFields.dataPrimeiroVencimento,
    idTipoFormaPagto: formFields.idTipoFormaPagto,
    ehMemoriaDeCalculo,
  };
}

export function makePayloadParcelas(dadosResumo, idProcesso, formFields) {
  return {
    idProcesso,
    valorTotal: String(dadosResumo.valorTotal),
    qtdeParcelas: formFields.quantidadeParcelas,
    intervaloParcelas: formFields.idIntervaloPagamento,
    primeiroVencimento: formFields.dataPrimeiroVencimento,
    idTipoFormaPagto: formFields.idTipoFormaPagto,
  };
}

export function buildParcelas(data) {
  return data.map(parcela => ({
    formaPagamento: parcela.idTipoFormaPagto,
    vencimento: DateUtils.formatTextDate(parcela.dataVencimento),
    valor: parcela.valor,
    nParcela: parcela.nroParcela,
    redistribuirValores: parcela.redistribuirValores,
    chequeDetalhe: parcela.chequeDetalhe,
  }));
}

function temCorDiferenteDeSucesso(jsonErros, comparar) {
  return Object.entries(jsonErros).some(([chave, valor]) => chave.startsWith('cor') && comparar(valor));
}

export function temAlerta(jsonErros) {
  return temCorDiferenteDeSucesso(jsonErros, valor => valor === 'ALERTA');
}

export function temThumbsDown(jsonErros) {
  return temCorDiferenteDeSucesso(jsonErros, valor => valor !== 'SUCESSO' && valor !== 'ALERTA');
}
